export default "//cdn.scentbird.com/assets/frontbird-site/images/golfing_962f70.jpg";